/*
 * Defines actions.
 */

const constants = {
  INIT_PLUGINS: 'INIT_PLUGINS',
  SET_APP_DB: 'SET_APP_DB',
  SET_NEO_DATASETS: 'SET_NEO_DATASETS',
  SET_NEO_SERVER: 'SET_NEO_SERVER',
  SET_NEO_SERVER_PUBLIC: 'SET_NEO_SERVER_PUBLIC',
  SET_NEO_SERVER_PUBLIC_LOADED: 'SET_NEO_SERVER_PUBLIC_LOADED',
  SET_NEO_MESHINFO: 'SET_NEO_MESHINFO',
  SET_NEO_ROIINFO: 'SET_NEO_ROIINFO',
  SET_NEO_DATASET_COLUMN_DEFAULTS: 'SET_NEO_DATASET_COLUMN_DEFAULTS',
  UPDATE_RESULTS: 'UPDATE_RESULTS',
  CLEAR_RESULT: 'CLEAR_RESULT',
  CLEAR_CACHE: 'CLEAR_CACHE',
  CLEAR_NEW_RESULT: 'CLEAR_NEW_RESULT',
  REFRESH_RESULT: 'REFRESH_RESULT',
  UPDATE_QUERY: 'UPDATE_QUERY',
  APP_SET_SELECTED_RESULT: 'APP_SET_SELECTED_RESULT',
  LOGIN_USER: 'LOGIN_USER',
  LOGIN_CHECK: 'LOGIN_CHECK',
  LOGIN_FAILED: 'LOGIN_FAILED',
  SET_USER_TOKEN: 'SET_USER_TOKEN',
  LOGOUT_USER: 'LOGOUT_USER',
  AUTH_ERROR: 'AUTH_ERROR',
  META_INFO_ERROR: 'META_INFO_ERROR',
  API_ERROR: 'API_ERROR',
  PLUGIN_SUBMITTING: 'PLUGIN_SUBMITTING',
  PLUGIN_SAVE_RESPONSE: 'PLUGIN_SAVE_RESPONSE',
  PLUGIN_CACHE_HIT: 'PLUGIN_CACHE_HIT',
  PLUGIN_SUBMIT_ERROR: 'PLUGIN_SUBMIT_ERROR',
  PLUGIN_RESPONSE_ERROR: 'PLUGIN_RESPONSE_ERROR',
  INIT_VIEWPLUGINS: 'INIT_VIEWPLUGINS',
  SKELETON_ADD_ID: 'SKELETON_ADD_ID',
  SKELETON_ADD_BODIES: 'SKELETON_ADD_BODIES',
  SKELETON_CLEAR: 'SKELETON_CLEAR',
  SKELETON_REMOVE: 'SKELETON_REMOVE',
  SKELETON_SYNAPSE_LOAD: 'SKELETON_SYNAPSE_LOAD',
  SKELETON_SYNAPSE_LOADING: 'SKELETON_SYNAPSE_LOADING',
  SKELETON_SYNAPSE_LOADED: 'SKELETON_SYNAPSE_LOADED',
  SKELETON_SYNAPSE_REMOVE: 'SKELETON_SYNAPSE_REMOVE',
  SKELETON_SYNAPSE_COLOR_UPDATE: 'SKELETON_SYNAPSE_COLOR_UPDATE',
  SKELETON_SPINDLE_TOGGLE: 'SKELETON_SPINDLE_TOGGLE',
  AXIS_LINE_TOGGLE: 'AXIS_LINE_TOGGLE',
  SKELETON_SYNAPSES_ON_TOP_TOGGLE: 'SKELETON_SYNAPSES_ON_TOP_TOGGLE',
  SKELETON_SYNAPSE_RADIUS_SET: 'SKELETON_SYNAPSE_RADIUS_SET',
  SET_FULLSCREEN_VIEWER: 'SET_FULLSCREEN_VIEWER',
  CLEAR_FULLSCREEN_VIEWER: 'CLEAR_FULLSCREEN_VIEWER',
  CLEAR_ERRORS: 'CLEAR_ERRORS',
  CLEAR_NOTIFICATION: 'CLEAR_NOTIFICATION',
  NOTIFICATION: 'NOTIFICATION',
  NEUROGLANCER_ADD_ID: 'NEUROGLANCER_ADD_ID',
  TOGGLE_CYPHER_DISPLAY: 'TOGGLE_CYPHER_DISPLAY',
  COLUMN_UPDATE_STATUS: 'COLUMN_UPDATE_STATUS',
  COLUMN_INIT_STATUS: 'COLUMN_INIT_STATUS',
  QUERY_TYPE_TAB_TOGGLE: 'QUERY_TYPE_TAB_TOGGLE',
  SET_VIMO_URL: 'SET_VIMO_URL'
};
export default constants;
